import React from 'react'
import styles from "./loading.module.css"

const Loading = () => {
    return (
        <div className={styles.loadContainer}>
            <div className={styles.load}></div>
        </div>
    )
}

export default Loading